const firebaseConfig = {
  apiKey: "AIzaSyCfxefiDjmN5P6OyGSOP9RLch4KpWCy5ME",
  authDomain: "newsy-7a691.firebaseapp.com",
  databaseURL: "https://newsy-7a691.firebaseio.com",
  projectId: "newsy-7a691",
  storageBucket: "newsy-7a691.appspot.com",
  messagingSenderId: "834068196796",
  appId: "1:834068196796:web:133bfd46bdec936fad4fb9",
};

export default firebaseConfig;